export * from './scrap-confirm-icon.component';